import { render, staticRenderFns } from "./orcid-collection.vue?vue&type=template&id=1e61d6e4&scoped=true&lang=html"
import script from "./orcid-collection.vue?vue&type=script&lang=js"
export * from "./orcid-collection.vue?vue&type=script&lang=js"
import style0 from "./orcid-collection.vue?vue&type=style&index=0&id=1e61d6e4&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e61d6e4",
  null
  
)

export default component.exports